.scheduleRow {
  display: flex;
  gap: 16px;
  width: 100%;

  & > * {
    flex: 1;
    min-width: 0;
  }
}

// Each basis fits the widest label its select can show, so the row only wraps
// when the drawer is too narrow for that.
.scheduleRowWithDeliveryRange {
  flex-wrap: wrap;

  & > .frequencyField {
    flex: 1 1 113px;
  }

  & > .frequencyFieldMonthlyByDate {
    flex: 1 1 171px;
  }

  & > .occurrenceField {
    flex: 1 1 109px;
  }

  & > .dayField {
    flex: 1 1 138px;
  }

  & > .dayOfMonthField {
    flex: 1 1 71px;
  }

  & > .deliveryField {
    flex: 1 1 239px;
  }

  // Monthly has four selects, which do not fit one row with the delivery range.
  & > .deliveryFieldOwnRow {
    flex: 1 1 100%;
  }
}
